import React__default from 'react';
import classNames from './../external_lib/classnames/index.js';

function Anchor(_a) {
    var children = _a.children, classes = _a.classes, href = _a.href, _b = _a.newTab, newTab = _b === void 0 ? false : _b;
    return (React__default.createElement("a", { className: classNames('anchor-tag', classes), href: href, rel: "noreferrer", target: newTab ? '_blank' : '_self' }, children));
}

export { Anchor as default };
//# sourceMappingURL=Anchor.js.map
